export default __webpack_public_path__ + "static/media/techware.1e05f7d9.png";